import script from "./NotFoundsView.vue?vue&type=script&setup=true&lang=js"
export * from "./NotFoundsView.vue?vue&type=script&setup=true&lang=js"

import "./NotFoundsView.vue?vue&type=style&index=0&id=7e159b2f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e159b2f"]])

export default __exports__